module.exports = __webpack_public_path__ + "assets/row-dark621744.png";